import { compact, uniq } from 'lodash-es';

// Минимальный интерфейс для работы функций
// Совместим с SerializedSeatmap из freedom-cabinet и freedom-avia
export interface SeatMapForUtils {
  rows: Array<{
    seats: Array<{
      exists?: boolean;
      available?: boolean;
      price?: { amount?: string | number };
    }>;
  }>;
}

/**
 * Generates a random pastel color in hexadecimal format.
 * Pastel colors are created by using RGB values in the range 128-255.
 *
 * @returns A hexadecimal color string in uppercase (e.g., "#FFAABB")
 */
export function generateRandomPastelColor(): string {
  // Generate random values for the R, G, and B components to create a pastel color.
  const r = Math.floor(Math.random() * 128) + 128; // Red component
  const g = Math.floor(Math.random() * 128) + 128; // Green component
  const b = Math.floor(Math.random() * 128) + 128; // Blue component

  // Convert the RGB values to hexadecimal and format them as a string.
  const hexColor = `#${r.toString(16)}${g.toString(16)}${b.toString(16)}`;

  return hexColor.toUpperCase(); // Convert the color to uppercase for consistency
}

/**
 * Extracts unique seat prices from a seatmap, sorted in descending order.
 * Only considers seats that exist and are available.
 *
 * @param seatmap - The seatmap containing rows and seats
 * @returns An array of unique price strings, sorted from highest to lowest
 */
export function getSeatMapUniqPrices<T extends SeatMapForUtils>(
  seatmap: T,
): string[] {
  const availableSeatsPrice = compact(
    seatmap.rows.flatMap(row =>
      row.seats.map(seat => {
        if (seat.exists && seat.available && seat.price?.amount != null) {
          return Number(seat.price.amount);
        }
        return null;
      }),
    ),
  );
  return uniq(
    availableSeatsPrice.sort((a, b) => b - a).map(price => String(price)),
  );
}
